module.exports = __webpack_public_path__ + "img/10查看计算结果.38e96143.gif";